import isControllerType from '@utils/isControllerType';
import { DateTime } from 'luxon';

export enum ControllerType {
  E2 = 'e2',
  E3 = 'e3',
  SiteSupervisor = 'sitesupervisor',
  'Site Supervisor' = 'site supervisor',
  AKSC255 = 'aksc255',
  SM880 = 'sm880',
  SM880A = 'sm880a',
  SM800A = 'sm800a',
  SM800SA = 'sm800s/a',
  SYMBIO800 = 'symbio 800',
  LennoxM4Core = 'lennox m4 core',
  XR75CH = 'dixel xr75ch',
  EV3224 = 'ev3224',
  EV3273 = 'ev3273',
  EV3283 = 'ev3283',
  KiloNode = 'kilonode',
  EvcoRtu = 'evco rtu',
  LeoRtu = 'leo rtu',
  EvcoAhu = 'evco ahu',
  LeoAhu = 'leo ahu',
  EvcoRtuV2 = 'evco rtu v2',
  LeoRtuV2 = 'leo rtu v2',
  EvcoRtuZones = 'evco rtu zones',
  LeoRtuZones = 'leo rtu zones',
  EvcoRtuZonesV2 = 'evco rtu zones v2',
  LeoRtuZonesV2 = 'leo rtu zones v2',
  EvcoLighting = 'evco lighting',
  LeoLighting = 'leo lighting',
  EvcoLightingV2 = 'evco lighting v2',
  LeoLightingV2 = 'leo lighting v2',
  EvcoMonitor = 'evco monitor',
  LeoMonitor = 'leo monitor',
  EvcoPowerMonitor = 'evco power monitor',
  LeoPowerMonitor = 'leo power monitor',
  EvcoHgmMz = 'evco hgm-mz',
  LeoHgmMz = 'leo hgm-mz',
  EvcoHgmSz = 'evco hgm-sz',
  LeoHgmSz = 'leo hgm-sz',
  EVCO_CONDENSING_UNIT = 'evco condensing unit',
  LeoCondensingUnit = 'leo condensing unit',
  EvcoPumpStation = 'evco pump station',
  HGMMZ = 'hgm-mz',
  EvcoCaseMonitor = 'evco case monitor',
  LeoCaseMonitor = 'leo case monitor',
}

export const CustomLeoControllers = [
  ControllerType.LeoRtu,
  ControllerType.LeoRtuV2,
  ControllerType.LeoRtuZones,
  ControllerType.LeoRtuZonesV2,
  ControllerType.LeoLighting,
  ControllerType.LeoLightingV2,
  ControllerType.LeoMonitor,
  ControllerType.LeoPowerMonitor,
  ControllerType.LeoHgmMz,
  ControllerType.LeoHgmSz,
  ControllerType.LeoCondensingUnit,
  ControllerType.LeoAhu,
];

export const CustomEvcoControllers = [
  ControllerType.EV3224,
  ControllerType.KiloNode,
  ControllerType.EvcoRtu,
  ControllerType.EvcoRtuV2,
  ControllerType.EvcoRtuZones,
  ControllerType.EvcoRtuZonesV2,
  ControllerType.EvcoLighting,
  ControllerType.EvcoLightingV2,
  ControllerType.EvcoMonitor,
  ControllerType.EvcoPowerMonitor,
  ControllerType.EvcoHgmMz,
  ControllerType.EvcoHgmSz,
  ControllerType.EVCO_CONDENSING_UNIT,
  ControllerType.EvcoPumpStation,
  ...CustomLeoControllers,
];

export const TerminalModeControllers = [
  ControllerType.E2,
  ControllerType.E3,
  ControllerType.SiteSupervisor,
  ControllerType['Site Supervisor'],
  ControllerType.KiloNode,
  ControllerType.LeoAhu,
  ControllerType.EvcoRtu,
  ControllerType.LeoRtu,
  ControllerType.EvcoRtuV2,
  ControllerType.LeoRtuV2,
  ControllerType.EvcoRtuZones,
  ControllerType.LeoRtuZones,
  ControllerType.EvcoRtuZonesV2,
  ControllerType.LeoRtuZonesV2,
  ControllerType.EvcoLighting,
  ControllerType.LeoLighting,
  ControllerType.EvcoLightingV2,
  ControllerType.LeoLightingV2,
  ControllerType.EvcoMonitor,
  ControllerType.LeoMonitor,
  ControllerType.EvcoPowerMonitor,
  ControllerType.LeoPowerMonitor,
  ControllerType.EvcoHgmMz,
  ControllerType.LeoHgmMz,
  ControllerType.EvcoHgmSz,
  ControllerType.LeoHgmSz,
  ControllerType.EVCO_CONDENSING_UNIT,
  ControllerType.LeoCondensingUnit,
  ControllerType.SM880,
  ControllerType.SM800A,
  ControllerType.SM800SA,
];

export const isCustomEvcoController = (controllerType: ControllerType) => {
  return isControllerType(controllerType, CustomEvcoControllers);
};

export const validPasswordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;

export const CaseTempsV1EndDate = DateTime.fromObject({
  year: 2026,
  month: 1,
  day: 19,
});

export const isTestServer = window.location.origin.includes('lc2-react-test');
